import { mobileTextCss, textCss } from 'common/utils/styleUtilsNew'
import styled from 'styled-components'

type WebinarSessionLinkUiNewProps = {
  color: string
  mobileColor?: string
  fontSize: number
  mobileFontSize?: number
}
const WebinarSessionLinkUiNew = styled.a<WebinarSessionLinkUiNewProps>`
  word-break: break-word;
  ${textCss}
  ${p => p.theme.isEditorMobileMode && mobileTextCss}
  ${p => p.theme.phone} {
    ${mobileTextCss}
  }
`

export default WebinarSessionLinkUiNew
